import { render, staticRenderFns } from "./ProductLibrary.vue?vue&type=template&id=45580ad4&scoped=true"
import script from "./ProductLibrary.vue?vue&type=script&lang=js"
export * from "./ProductLibrary.vue?vue&type=script&lang=js"
import style0 from "./ProductLibrary.vue?vue&type=style&index=0&id=45580ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45580ad4",
  null
  
)

export default component.exports